<template>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2H4.67777V3.7011H8.78536L2 10V13L10.3034 5.22313V9.34158H12V2Z" fill="currentColor" />
  </svg>
</template>
<script lang="ts" setup></script>
